export default __webpack_public_path__ + "static/media/HeroSVG3.b2b38713.png";